import { docReady } from '../helpers/docReady';
import '../../styles/templates/product.scss';
docReady(() => {
    // console.log('Product Template JS Ready');});
});
